<!-- Mobile backdrop -->
@if (mobileOpen()) {
  <div class="fixed inset-0 bg-black/40 z-[35] md:hidden" (click)="closeMobile()"></div>
}

<!-- Mobile hamburger button -->
<button
  (click)="toggleMobile()"
  class="fixed top-4 z-50 md:hidden p-2 rounded-lg bg-white border border-stone-200 shadow-sm transition-[left] duration-300"
  [style.left]="mobileOpen() ? 'calc(16rem + 0.75rem)' : '0.75rem'"
  [attr.aria-expanded]="mobileOpen()"
  aria-label="Menu"
  title="Menu"
>
  <svg class="w-5 h-5 text-stone-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    @if (mobileOpen()) {
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    } @else {
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
    }
  </svg>
</button>

<aside
  class="fixed left-0 top-0 bottom-0 min-h-dvh h-screen transition-all duration-300 z-40 flex flex-col federation-view"
  style="background-color: #1f2937;"
  [class.w-64]="isOpen()"
  [class.w-20]="!isOpen()"
  [class.sidebar-mobile-open]="mobileOpen()"
>
  <!-- Sidebar Header with Federation Logo -->
  <div [style.padding]="'12px'" [style.height]="'4.5rem'" class="border-b border-stone-700 flex items-center">
    @if (isOpen()) {
      <div class="w-full flex items-center justify-center">
        <img src="assets/img/sportiq-logo-v2.png" alt="SportIQ" [style.height]="'3rem'" class="object-contain" />
      </div>
    }
  </div>

  <!-- Toggle Button - Always visible, floating outside -->
  <button
    (click)="toggleSidebar()"
    class="absolute top-20 -right-5 p-2 rounded-lg transition-all z-50 hidden md:block"
    style="border: 3px solid #fafbf6; background-color: #111827; color: #fafbf6;"
    title="Afficher / masquer le menu"
  >
    <svg class="w-4 h-4 transition-transform" style="stroke: #fafbf6;" [style.transform]="!isOpen() ? 'scaleX(-1)' : 'scaleX(1)'" fill="none" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <!-- "Fédération de travail": the one place that says WHICH federation the backoffice shows -->
  @if (isOpen()) {
    <section class="px-3 pt-4" aria-label="Fédération de travail">
      <div class="rounded-xl bg-white/5 border border-white/10 p-3">
        <p class="text-[11px] uppercase tracking-wider text-stone-400 font-semibold">Fédération de travail</p>
        @if (federation(); as f) {
          <div class="mt-2 flex items-center gap-3">
            <div class="w-10 h-10 rounded-lg bg-white text-stone-800 font-bold text-[10px] flex items-center justify-center flex-shrink-0 overflow-hidden">
              @if (f.logo_url && failedLogo() !== f.logo_url) {
                <img [src]="f.logo_url" [alt]="'Logo ' + f.federation_acornyme" (error)="failedLogo.set(f.logo_url)" class="w-full h-full object-contain" />
              } @else {
                {{ f.federation_acornyme }}
              }
            </div>
            <div class="min-w-0">
              <p class="font-semibold text-sm text-white">{{ f.federation_acornyme }}</p>
              <p class="text-[11px] text-stone-400 truncate" [title]="f.federation_name">{{ f.federation_name }}</p>
            </div>
          </div>
          <div class="mt-3 grid grid-cols-2 gap-2">
            <button type="button" (click)="openSwitcher()" aria-label="Changer de fédération"
              class="min-h-[36px] text-xs font-semibold px-2 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-white inline-flex items-center justify-center gap-1">
              <span class="material-icons" style="font-size: 16px;">swap_horiz</span> Changer
            </button>
            @if (hasPlatformRights()) {
              <button type="button" (click)="leaveFederation()" [disabled]="leaving()" aria-label="Quitter la fédération (retour à la plateforme)"
                class="min-h-[36px] text-xs font-semibold px-2 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-white inline-flex items-center justify-center gap-1 disabled:opacity-60">
                <span class="material-icons" style="font-size: 16px;">logout</span> Quitter
              </button>
            }
          </div>
        } @else {
          <p class="mt-1 text-sm text-stone-300">Aucune fédération choisie</p>
          <p class="text-[11px] text-stone-500 mt-1">Le backoffice (cartes, clubs, licenciés…) s'ouvre sur UNE fédération.</p>
          <button type="button" (click)="openSwitcher()"
            class="mt-3 w-full min-h-[36px] inline-flex items-center justify-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-lg bg-primary-600 hover:bg-primary-700 text-white">
            <span class="material-icons" style="font-size: 16px;">login</span> Choisir une fédération
          </button>
        }
      </div>
    </section>
  }

  <!-- Menu Items -->
  <nav class="flex-1 px-3 py-4 space-y-2 overflow-y-auto" aria-label="Menu principal">
    @if (isOpen()) {
      <!-- Zone PLATEFORME: never depends on a chosen federation -->
      @if (hasPlatformRights()) {
        <div class="space-y-1">
          <p class="sidebar-section-title"><span class="material-icons" style="font-size: 14px;">public</span> Plateforme — toutes les fédérations</p>
          <button type="button" (click)="go('/plateforme/federations')" title="Fédérations"
            class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
            [class.bg-stone-700]="isPlatformListActive()" [class.text-stone-300]="!isPlatformListActive()">
            <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center"><span class="material-icons text-sm">domain</span></span>
            <span class="text-sm font-medium truncate">Fédérations</span>
            @if (federationsCount() !== null) {
              <span class="ml-auto text-[11px] bg-white/10 px-2 py-0.5 rounded-full">{{ federationsCount() }}</span>
            }
          </button>
          @if (canCreateFederation()) {
            <button type="button" (click)="go('/plateforme/federations/nouvelle')" title="Nouvelle fédération"
              class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
              [class.bg-stone-700]="isPlatformCreateActive()" [class.text-stone-300]="!isPlatformCreateActive()">
              <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center"><span class="material-icons text-sm">add_business</span></span>
              <span class="text-sm font-medium truncate">Nouvelle fédération</span>
            </button>
          }
          @if (canReadPlatform('platform_users')) {
            <button type="button" (click)="go('/plateforme/comptes')" title="Comptes plateforme"
              class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
              [class.bg-stone-700]="isRouteActive('/plateforme/comptes')" [class.text-stone-300]="!isRouteActive('/plateforme/comptes')">
              <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center"><span class="material-icons text-sm">manage_accounts</span></span>
              <span class="text-sm font-medium truncate">Comptes plateforme</span>
            </button>
          }
          @if (canReadPlatform('platform_roles')) {
            <button type="button" (click)="go('/plateforme/roles')" title="Rôles plateforme"
              class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
              [class.bg-stone-700]="isRouteActive('/plateforme/roles')" [class.text-stone-300]="!isRouteActive('/plateforme/roles')">
              <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center"><span class="material-icons text-sm">admin_panel_settings</span></span>
              <span class="text-sm font-medium truncate">Rôles plateforme</span>
            </button>
          }
        </div>
      }

      <!-- Zone BACKOFFICE: only the chosen federation -->
      @if (federation(); as f) {
        <p class="sidebar-section-title mt-2"><span class="material-icons" style="font-size: 14px;">badge</span> Backoffice — {{ f.federation_acornyme }}</p>
      } @else {
        <p class="sidebar-section-title mt-2"><span class="material-icons" style="font-size: 14px;">badge</span> Backoffice fédération</p>
        <div class="mx-1 rounded-lg border border-dashed border-white/15 p-3 text-[12px] text-stone-400">
          Choisissez une fédération pour voir son tableau de bord, ses campagnes, ses licenciés et la génération des cartes.
        </div>
      }
      <div class="space-y-2">
        @for (item of menuItems(); track item.label) {
          @if (!item.children || item.children.length === 0) {
            @if (item.route === '' || item.route === undefined) {
              <div class="px-4 py-3 text-sm font-medium text-stone-400">{{ item.label }}</div>
            } @else {
              <button
                (click)="navigateTo(item)"
                class="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
                [class.bg-stone-700]="isActive(item.route)"
                [title]="item.label"
              >
                <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center"
                  [style.color]="isActive(item.route) ? '#24d266' : '#9ca3af'">
                  <span class="material-icons text-sm">{{ item.icon }}</span>
                </span>
                <span class="text-sm font-medium truncate" [style.color]="isActive(item.route) ? '#24d266' : null" [class.text-stone-300]="!isActive(item.route)">{{ item.label }}</span>
              </button>
            }
          } @else {
            <div class="px-4 pt-4 pb-2 flex items-center gap-2">
              <span class="text-xs font-bold tracking-widest" [class.text-stone-400]="!item.badgePulse" [style.color]="item.badgePulse ? '#10b981' : null">{{ item.label }}</span>
              @if (!item.hideBadge) {
                <span class="relative flex h-2 w-2 flex-shrink-0">
                  @if (item.badgePulse) {
                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                  } @else {
                    <span class="relative inline-flex rounded-full h-2 w-2 bg-stone-500"></span>
                  }
                </span>
              }
            </div>
            <div class="ml-4 mt-1 space-y-1 border-l border-stone-600 pl-3">
              @for (child of item.children; track child.label) {
                <button
                  (click)="navigateTo(child)"
                  class="w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 text-sm hover:bg-stone-700/60 hover:text-white"
                  [class.bg-stone-700]="isChildActive(child.route)"
                  [style.color]="isChildActive(child.route) ? '#24d266' : null"
                  [class.text-stone-400]="!isChildActive(child.route)"
                  [title]="child.label"
                >
                  <span class="flex-shrink-0 w-4 h-4 flex items-center justify-center text-xs" [style.color]="isChildActive(child.route) ? '#24d266' : '#9ca3af'">
                    <span class="material-icons" style="font-size: 16px;">{{ child.icon }}</span>
                  </span>
                  <span class="truncate">{{ child.label }}</span>
                </button>
              }
            </div>
          }
        }
      </div>
    }

    <!-- Collapsed View Icons Only -->
    @if (!isOpen()) {
      <div class="space-y-3 mt-4">
        <button type="button" (click)="openSwitcher()" class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
          [title]="federation() ? 'Fédération de travail : ' + federation()!.federation_acornyme + ' (changer)' : 'Choisir une fédération'"
          [attr.aria-label]="federation() ? 'Changer de fédération (actuelle : ' + federation()!.federation_acornyme + ')' : 'Choisir une fédération'">
          <span class="material-icons text-sm">{{ federation() ? 'swap_horiz' : 'login' }}</span>
        </button>
        @if (hasPlatformRights()) {
          <button type="button" (click)="go('/plateforme/federations')" title="Fédérations" aria-label="Fédérations"
            class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60" [class.bg-stone-700]="isPlatformListActive()">
            <span class="material-icons text-sm">domain</span>
          </button>
          @if (canCreateFederation()) {
            <button type="button" (click)="go('/plateforme/federations/nouvelle')" title="Nouvelle fédération" aria-label="Nouvelle fédération"
              class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60" [class.bg-stone-700]="isPlatformCreateActive()">
              <span class="material-icons text-sm">add_business</span>
            </button>
          }
          @if (canReadPlatform('platform_users')) {
            <button type="button" (click)="go('/plateforme/comptes')" title="Comptes plateforme" aria-label="Comptes plateforme"
              class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60" [class.bg-stone-700]="isRouteActive('/plateforme/comptes')">
              <span class="material-icons text-sm">manage_accounts</span>
            </button>
          }
          @if (canReadPlatform('platform_roles')) {
            <button type="button" (click)="go('/plateforme/roles')" title="Rôles plateforme" aria-label="Rôles plateforme"
              class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60" [class.bg-stone-700]="isRouteActive('/plateforme/roles')">
              <span class="material-icons text-sm">admin_panel_settings</span>
            </button>
          }
          <hr class="border-stone-700 mx-2" />
        }
        @for (item of menuItems(); track item.label) {
          @if (!item.children || item.children.length === 0) {
            @if (item.route && item.route !== '') {
              <button
                (click)="navigateTo(item)"
                class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
                [class.bg-stone-700]="isActive(item.route)"
                [title]="item.label"
              >
                <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center"
                  [style.color]="isActive(item.route) ? '#24d266' : '#9ca3af'">
                  <span class="material-icons text-sm">{{ item.icon }}</span>
                </span>
              </button>
            }
          } @else {
            @for (child of item.children; track child.label) {
              <button
                (click)="navigateTo(child)"
                class="w-full flex items-center justify-center p-3 rounded-lg transition-all duration-200 hover:bg-stone-700/60"
                [class.bg-stone-700]="isActive(child.route)"
                [title]="child.label"
              >
                <span class="flex-shrink-0 w-6 h-6 flex items-center justify-center"
                  [style.color]="isActive(child.route) ? '#24d266' : '#9ca3af'">
                  <span class="material-icons text-sm">{{ child.icon }}</span>
                </span>
              </button>
            }
          }
        }
      </div>
    }
  </nav>

  <!-- Footer: Version -->
  <div class="border-t border-stone-700 px-3 py-4">
    @if (isOpen()) {
      <div class="px-4 py-2 text-center">
        <p class="text-xs text-stone-500">Version {{ version() }}</p>
      </div>
    }
  </div>
</aside>

<!-- Main Content Offset (desktop only) -->
<div
  class="transition-all duration-300 hidden md:block flex-shrink-0"
  [class.md:w-64]="isOpen()"
  [class.md:w-20]="!isOpen()"
  [class.w-64]="isOpen()"
  [class.w-20]="!isOpen()"
  style="background-color: #1f2937;"
></div>

<!-- Switcher dialog: open the backoffice of one federation (POST /auth/select-federation) -->
@if (switcherOpen()) {
  <div class="fixed inset-0 z-[60]" role="dialog" aria-modal="true" aria-labelledby="switcher-title">
    <div class="absolute inset-0 bg-black/40" (click)="closeSwitcher()"></div>
    <div class="relative mx-auto mt-16 sm:mt-24 w-[calc(100%-2rem)] max-w-md bg-white rounded-2xl shadow-xl overflow-hidden text-stone-800">
      <div class="p-4 border-b border-stone-100">
        <h2 id="switcher-title" class="font-semibold">Ouvrir le backoffice d'une fédération</h2>
        <div class="relative mt-3">
          <span class="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-base text-stone-400">search</span>
          <input type="text" [ngModel]="switcherSearch()" (ngModelChange)="switcherSearch.set($event)" placeholder="Rechercher (acronyme, nom)…"
            aria-label="Rechercher une fédération"
            class="w-full pl-9 pr-3 py-2 rounded-lg border border-stone-200 text-sm focus:outline-none focus:ring-2 focus:ring-primary-100" />
        </div>
      </div>
      @if (switcherError()) {
        <p role="alert" class="mx-4 mt-3 rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">{{ switcherError() }}</p>
      }
      <ul class="max-h-80 overflow-y-auto">
        @if (switcherLoading()) {
          <li class="px-4 py-6 text-center text-sm text-stone-400">Chargement…</li>
        } @else {
          @for (x of switcherFiltered(); track x.federation_id) {
            <li>
              <button type="button" (click)="chooseFederation(x)" [disabled]="switching() !== null"
                class="w-full text-left px-4 py-3 hover:bg-stone-50 flex items-center justify-between gap-3 border-b border-stone-50 disabled:opacity-60">
                <span class="min-w-0">
                  <span class="block font-semibold text-sm">{{ x.federation_acornyme }}</span>
                  <span class="block text-xs text-stone-500 truncate">{{ x.federation_name }}</span>
                </span>
                <span class="text-xs text-primary-600 font-medium flex-shrink-0">
                  {{ switching() === x.federation_id ? 'Ouverture…' : (x.federation_id === federation()?.federation_id ? 'Actuelle' : 'Ouvrir') }}
                </span>
              </button>
            </li>
          } @empty {
            <li class="px-4 py-6 text-center text-sm text-stone-400">Aucune fédération</li>
          }
        }
      </ul>
      <div class="p-3 border-t border-stone-100 text-right">
        <button type="button" (click)="closeSwitcher()" class="text-sm min-h-[36px] px-4 py-2 rounded-lg border border-stone-200 hover:bg-stone-50">Fermer</button>
      </div>
    </div>
  </div>
}
